export const QUERY_KEYS = {
  paywall: 'paywall',
  cuInfo: 'cuInfo',
  dataPreparerDownloadStatus: 'dataPreparerDownloadStatus',
  dataPreparerInfo: 'dataPreparerInfo',
  airesFilesIsEmpty: 'airesFilesIsEmpty',
  submissions: 'submissions',
  airesData: 'airesData',
  airesFilesStatuses: 'airesFilesStatuses',
  airesMappingStatus: 'airesMappingStatus',
  loansMappingData: 'loansMappingData',
  sharesMappingData: 'sharesMappingData',
  loansTypes: 'loansTypes',
  sharesTypes: 'sharesTypes',
  saveLoanType: 'saveLoanType',
  saveShareType: 'saveShareType',
  assignMappingData: 'assignMappingData',
  savePrefilledTemplate: 'savePrefilledTemplate',
  pfcMappingData: 'pfcMappingData',
  pfcMeaningData: 'pfcMeaningData',
  mapPfcRow: 'mapPfcRow',
  mapPfcRows: 'mapPfcRows',
  submitPfcDefinition: 'submitPfcDefinition',
  submissionHistory: 'submissionHistory',
  uiStatus: 'uiStatus',
  updateUiStatus: 'updateUiStatus',
} as const;
